module.exports = __webpack_public_path__ + "static/img/hatopress-reel-viemo-poster-1.6d55edf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/hatopress-reel-viemo-poster-1.jpg
// module id = 175
// module chunks = 1